import {
  Banner,
  BannerVariant,
  BannerStatus,
  BannerLeftAccessoryType,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

export const TooManyFailedAttemptsMessage = () => (
  <Banner
    variant={BannerVariant.Light}
    leftAccessory={{
      type: BannerLeftAccessoryType.Status,
      status: BannerStatus.Warning,
    }}
    title={
      <Trans id="sign-in-page.too-many-failed-attempts.title">
        Too many failed login attempts
      </Trans>
    }
  >
    <Trans id="please-contact-support">Please contact support.</Trans>
  </Banner>
);
